// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateMemberV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AccountMemberUpdated",
    "SubuserInvitationFailed"
  ]);
}

let variablesConverter = {"updateMemberToAccountInput":{},"__root":{"input":{"r":"updateMemberToAccountInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateMemberV5_AccountMemberUpdated_member":{"f":""},"updateMemberV5":{"u":"response_updateMemberV5"}}};

let wrapResponseConverterMap = {
  response_updateMemberV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateMemberV5_AccountMemberUpdated_member":{"f":""},"updateMemberV5":{"u":"response_updateMemberV5"}}};

let responseConverterMap = {
  response_updateMemberV5: unwrap_response_updateMemberV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function accountMemberRoleInput_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "ASSOCIATE" || $$enum === "SHOWING_ASSISTANT" || $$enum === "BUYER_SPECIALIST" || $$enum === "PARTNER" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "OPERATIONS_MANAGER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "MARKETING_SPECIALIST" || $$enum === "LISTING_MANAGER" || $$enum === "LISTING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRoleInput_fromString = accountMemberRoleInput_decode;

let Utils = {
  accountMemberRoleInput_decode: accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: accountMemberRoleInput_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "SubuserInvitationFailed",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubuserMemberEditForm_UpdateMemberV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMemberV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SubusersPageAccountsListItem_member"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SubuserMemberEditForm_member"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AccountMemberUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "SubuserMemberEditForm_UpdateMemberV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMemberV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "profilePhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "ratio",
                                "variableName": "__relay_internal__pv__DevicePixelRatio"
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 60
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AccountMemberUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90e84644eabcd6e71a18ac473896e020",
    "id": null,
    "metadata": {},
    "name": "SubuserMemberEditForm_UpdateMemberV5Mutation",
    "operationKind": "mutation",
    "text": "mutation SubuserMemberEditForm_UpdateMemberV5Mutation(\n  $input: UpdateMemberToAccountInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateMemberV5(input: $input) {\n    __typename\n    ... on SubuserInvitationFailed {\n      message\n    }\n    ... on AccountMemberUpdated {\n      member {\n        ...SubusersPageAccountsListItem_member\n        ...SubuserMemberEditForm_member\n        nodeId\n      }\n    }\n  }\n}\n\nfragment SubuserMemberEditForm_member on AccountMember {\n  id\n  role\n  agent {\n    firstName\n    lastName\n    displayName\n    emailAddress\n    nodeId\n  }\n}\n\nfragment SubusersPageAccountsListItem_member on AccountMember {\n  ...SubuserMemberEditForm_member\n  id\n  role\n  agent {\n    profilePhoto {\n      url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    }\n    firstName\n    lastName\n    displayName\n    emailAddress\n    nodeId\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_updateMemberV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateMemberV5 = unwrap_response_updateMemberV5;
exports.wrap_response_updateMemberV5 = wrap_response_updateMemberV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
